import React, { useEffect, useState } from 'react';
import type { FC, PropsWithChildren } from 'react';
import { ChangelogContext } from '../../contexts/ChangelogContext';

export const ChangelogProvider: FC<PropsWithChildren> = ({ children }) => {
  const [changelog, setChangelog] = useState<string>('');

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/CHANGELOG.md`)
      .then(async (res) => res.text())
      .then((changelog: string) => {
        setChangelog(changelog);
      })
      .catch((error) => {
        console.error(error);
        setChangelog('');
      });
  }, []);

  return (
    <ChangelogContext.Provider value={{ changelog }}>
      {children}
    </ChangelogContext.Provider>
  );
};
